import { css } from 'styled-components';

import { config } from '@/config.ts';

import { BREAKPOINTS } from '../../constants/breakpoints';

const getFontByBrand = () => {
	switch (config.BRAND) {
		case 'pm':
			return "'Parimatch Sans', -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
		default:
			return "'Open Sans', -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif";
	}
};

export const Reset = css`
	*,
	::before,
	::after {
		box-sizing: border-box;
		margin: 0;
		padding: 0;
		outline: 0;
	}

	html,
	body {
		height: 100%;
	}

	html {
		font-family: ${getFontByBrand()};
		z-index: 1;
		display: block;
		letter-spacing: -0.32px;
		line-height: 1.2;
		font-size: 20px;
		background-color: ${({ theme }) => theme.colors.background.main};
	}

	body {
		-webkit-font-smoothing: antialiased;
		text-rendering: geometricPrecision;
	}

	a {
		text-decoration: none;
		-webkit-app-region: no-drag;
	}

	input,
	textarea {
		font-family: ${getFontByBrand()};
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	ul,
	ol {
		margin-bottom: 0.5rem;
		line-height: 1.2;
		color: #faf9f8;
	}

	h3,
	h4,
	h5,
	h6 {
		font-size: 0.9rem;
		font-weight: 600;
		text-transform: none;
	}

	img,
	a,
	picture {
		-webkit-user-drag: none;
	}

	img {
		max-width: 100%;
		border: 0 none;
		outline: 0 none;
	}

	hr {
		margin: 1rem 0;
		border: none;
		border-top: 1px solid #cdcdcd;
	}

	table {
		width: 100%;
		border-spacing: 0;
		border-collapse: collapse;
	}

	td {
		padding: 0.25rem 0.4rem;
		border: 1px solid #4d4848;
	}

	div {
		::-webkit-scrollbar {
			width: 10px;
			height: 10px;
		}

		::-webkit-scrollbar-track {
			background: #45423e;
		}

		::-webkit-scrollbar-thumb {
			background: rgba(250, 249, 248, 0.35);
			border-radius: 3px;
		}

		::-webkit-scrollbar-thumb:hover {
			background: rgba(250, 249, 248, 0.5);
		}

		scrollbar-width: thin;
		scrollbar-color: rgba(250, 249, 248, 0.35) #45423e;
	}

	ul,
	ol {
		list-style-position: inside;
		-webkit-app-region: no-drag;
	}

	button {
		background: none;
		border: none;
		cursor: pointer;
		font-family: inherit;
		-webkit-app-region: no-drag;
	}

	iframe {
		margin: 0;
		padding: 0;
	}

	[hidden] {
		display: none;
	}

	#root {
		user-select: none;
	}

	.react-joyride {
		&__spotlight {
			border: 4px solid #82d1ff;
			border-radius: 16px !important;
			background-color: rgba(217, 217, 217, 0.4) !important;
		}
		&__overlay {
			background-color: rgba(41, 38, 33, 0.8) !important;
		}
	}

	.__floater__arrow {
		display: none !important;
	}
	.__floater {
		@media (${BREAKPOINTS.NOT_DESKTOP}) {
			max-height: calc(100vh - 30px);
			max-width: calc(100vw - 30px) !important;
			width: 100%;
			top: 15px !important;
			transform: translateX(-50%) !important;
		}
	}

	.toast_wrapper {
		.Toastify {
			.Toastify__toast-container {
				position: fixed;
			}

			.Toastify__toast {
				background-color: #11362c;
				border-radius: 8px;
				font-family: inherit;
				font-size: 14px;

				&--success {
					background-color: #11362c;
					color: #07ef9c;
				}

				&--error {
					background-color: #2d1b1b;
					color: #ff6b6b;
				}

				.Toastify__close-button {
					display: none;
				}
			}
		}
	}

	.toast_wrapper_iframe {
		.Toastify {
			.Toastify__toast-container {
				top: 145px;
			}
		}
	}
`;
